import { gql } from "@apollo/client";

export const AddUserRights = gql`
  mutation AddUserRights(
    $token: String!
    $customerID: ID!
    $empID: ID!
    $user_details: SubscribedUser!
    $input: UserRights!
  ) {
    AddUserRights(
      token: $token
      customerID: $customerID
      empID: $empID
      user_details: $user_details
      input: $input
    )
  }
`;

export const UpdateUserRights = gql`
  mutation UpdateUserRights(
    $token: String!
    $customerID: ID!
    $empID: ID!
    $user_details: SubscribedUser!
    $input: UserRights!
  ) {
    UpdateUserRights(
      token: $token
      customerID: $customerID
      empID: $empID
      user_details: $user_details
      input: $input
    )
  }
`;
